import React, { useEffect, useRef } from 'react';
import axios from 'axios';

// Stands in for an older history turn's images and manual pages until the turn
// scrolls near the screen, then loads them once.
const LazyTurnMedia = ({ url, chatId, turnId, onLoaded, label }) => {
  const anchor = useRef(null);

  useEffect(() => {
    const load = async () => {
      try {
        const response = await axios.get(url, { params: { ChatId: chatId, TurnId: turnId } });
        onLoaded(turnId, response.data.images || [], response.data.manuals || []);
      } catch (error) {
        console.error('Error fetching history turn:', error);
        onLoaded(turnId, [], []);
      }
    };
    const observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) {
        observer.disconnect();
        load();
      }
    }, { rootMargin: '300px' });
    observer.observe(anchor.current);
    return () => observer.disconnect();
    // A turn loads once; its identity never changes while mounted.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [turnId]);

  return <div ref={anchor} className="lazy-turn-media">{label}</div>;
};

export default LazyTurnMedia;
